module.exports = __webpack_public_path__ + "img/cosgroveTech.74ff6c75.webp";